<template>
  <section id="content-requirements">
    <h2>Buyer Requirements</h2>

    <div class="info-grid">
        <div v-if="credentials" class="info-item-group list d-flex align-start">
            <img src="./assets/ribbon.svg" class="d-inline" />
            <div class="d-inline">
                <label class="d-block">Buyer Credentials</label>
                <span class="d-block">{{ credentials }}</span>
            </div>
        </div>

        <div v-if="organizations" class="info-item-group list d-flex" :class="(organizations || '').split(';').length > 1 ? 'align-start' : 'align-center'">
            <img src="./assets/brain-gears.svg" class="d-inline" />
            <div class="d-inline">
                <label class="d-block">{{ insuranceBasedListings.includes(practiceType) ? 'Associations' : 'Organizations' }}:</label>
                <template v-for="org in (organizations || '').split(';')">
                    <span :key="org" class="d-block pb-2">{{ org }}</span>
                </template>
            </div>
        </div>

      <div v-if="designations" class="info-item-group list d-flex align-start">
        <img src="./assets/briefcase.svg" class="d-inline" />
        <div class="d-inline">
            <label class="d-block">Designations:</label>
            <span class="d-block">{{ designations }}</span>
        </div>
      </div>

      <div v-if="location" class="info-item-group list">
        <img src="./assets/compass.svg" />
        <label>Location:</label>
        <span>{{ location }}</span>
      </div>

      <div v-if="other" class="info-item-group list d-flex align-start">
        <img src="./assets/arrow.svg" class="d-inline" />
        <div class="d-inline">
            <label class="d-block">Other Notes:</label>
            <span class="d-block">{{ other }}</span>
        </div>
      </div>

      <div v-if="showEmptyCell" class="info-item-group empty"></div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'DetailsBuyerInformation',
    props: {
        insuranceBasedListings: {
            type: Array,
            default: [],
        },
        practiceType: {
            type: Number,
            default: 1,
        },
        credentials: {
            type: String,
            default: '',
        },
        organizations: {
            type: String,
            default: '',
        },
        designations: {
            type: String,
            default: '',
        },
        location: {
            type: String,
            default: '',
        },
        other: {
            type: String,
            default: '',
        }
    },

    computed: {
        showEmptyCell () {
            let num = 0;
            if (this.credentials != null) num++
            if (this.organizations != null) num++
            if (this.designations != null) num++
            if (this.location != null) num++
            if (this.other != null) num++

            return num % 2 == 0 ? false : true;
        },
    }
}
</script>

<style scoped>
    .info-grid {
        background-color: #EFEFEF;
    }
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/BuyerInformation.vue